<template>
              <div  class='book_cover'>
                  <img class="image_div" :src="itemChild.bookLogoUrl" mode="" />
                <span class="book_name">{{ itemChild.bookName }}</span>
                <span class="sort" v-if="itemChild.category">{{
            itemChild.category.split(",")[0]
          }}</span>
            <p class="single-brief">{{ itemChild.bookSummary }}</p>
                </div>
</template>

<script>
import {Toast, MessageBox } from "mint-ui";
	export default {
		name: 'three_conpontent',
		props: {
            itemChild:{
				type: Object,
				default: {
                }
            }
		},
		data() {
			return {
			};
		},
		watch: {
			// current(val) {
			// 	if (val !== this.currentIndex) {
			// 		this.currentIndex = val;
			// 	}
			// }
		},
		methods: {
			
		},
		created() {
		}
	};
</script>

<style  scoped>
.book_cover{
  width: 149px;
  border-radius: 4px;
  padding:16px 8px;
  box-sizing: border-box;
  text-align: center;
}
.book_cover:nth-child(4n-3){
  background: #FDFAF6;
}
.book_cover:nth-child(4n-2),.book_cover:nth-child(4n-1){
  background:  #F9FBFF;
}
.book_cover:nth-child(4n){
  background: #FFF9F9;
}
.image_div {
  display: block;
  width: 78px;
  height: 104px;
  border-radius: 6px;
  margin:0 auto;
}
.book_name {
  overflow: hidden;
  -webkit-line-clamp: 1;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  font-size: 14px;
color: #333333;
line-height: 20px;
font-weight: 600;
  margin:10px auto;
  line-height: 20px;

  text-align: center;
}
.sort{
  background-color: rgb(253, 245, 233);
    border-radius: 4px;
    font-size: 12px;
    color: #f09b28;
    line-height: 18px;
    margin: 0 auto;
    padding:0 5px;
    display: inline-block;
}
.single-brief{
  margin-top:6px;
  font-size: 13px;
color: #666666;
  overflow: hidden;
  -webkit-line-clamp: 4;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  width:100%;
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/book_item/nine_compontent.vue